<template>
  <div class="spinner" :style="{ width: `${size}px`, height: `${size}px` }">
    <div class="spinner__bounce spinner__bounce--primary"></div>
    <div class="spinner__bounce spinner__bounce--secondary"></div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  size: {
    type: Number,
    default: 24
  }
});
</script>

<style scoped lang="scss">
.spinner {
  position: relative;
  display: inline-flex;
}

.spinner__bounce {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  position: absolute;
  opacity: 0.6;
  animation: sk-bounce 2s infinite ease-in-out;
}

.spinner__bounce--primary {
  background-color: $color-primary-500;
}

.spinner__bounce--secondary {
  background-color: $color-secondary-500;
  animation-delay: -1s;
}

@keyframes sk-bounce {
  0%,
  100% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
}
</style>
